import { useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { useGLTF, AccumulativeShadows } from '@react-three/drei';
import { useXRHitTest } from '@react-three/xr';

export function ARModel({ modelUrl }) {
  const { scene: gltfScene } = useGLTF(modelUrl);
  const ref = useRef();

  // Use hit test to place the model on the ground
  useXRHitTest((hitMatrix) => {
    hitMatrix.decompose(
      ref.current.position,
      ref.current.rotation,
      ref.current.scale
    );
  });

  return (
    <Canvas>
      <group ref={ref}>
        <primitive object={gltfScene} />
        <AccumulativeShadows
          temporal
          frames={100}
          scale={5}
          opacity={1}
          resolution={2048}
        />
      </group>
    </Canvas>
  );
}